export const getModal = state => state.modal;
export const getVisibleModal = state => state.modal.visibleModal;
export const getInfo = state => state.modal.info;
